<template>
  <section class="c-cbr-PageSection">
    <h3 
      v-if="headline" 
      class="c-cbr-PageSection-headline">{{ headline }}</h3>
    <slot/>
  </section>
</template>

<script>
  export default {
    props: {
      headline: {
        type: String,
        default: ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/ObjPageContainer.vue